import FileUploader from 'Shared/components/ImageUploader/FileUploader'
import './LogoSetting.scoped.scss'

export default function LogoSetting({ 
  label, 
  value, 
  onUploaded, 
  helpText, 
  className
}) {
  return (
    <div className="field logo-field margin-top half">
      <label>{label}</label>
      <div className="flex-center gap-10">
        <div>
          <FileUploader onUploaded={onUploaded} />
        </div>
        <div className={`logo-preview ${className}`}>
          {value && <img src={`/rails/active_storage/blobs/${value}/image.png`} />}
        </div>
      </div>
      <p className="help margin-top half">{helpText}</p>
    </div>
  )
}
